import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router'
import { Container, Grid, TextField, FormGroup, FormControlLabel, Checkbox, Button } from '@material-ui/core'
import { settingAPI } from './../services/SettingService'

const Setting_Create_Type = () => {
    let history = useHistory()
    const token = localStorage.getItem("Token")
    const [Type_Name, setType_Name] = useState("")
    const [due_time, setDue_time] = useState(1)
    const [GoogleDrive, SetGoogleDrive] = useState(false)
    const [Email, SetEmail] = useState(false)
    const [Buyer, SetByer] = useState(false)

    useEffect(() => {
        document.title = `Com7 Merchandise - สร้าง Type`
    }, [])

    const onSubmit = (e) => {
        e.preventDefault()
        Swal.fire({
            title: 'คุณแน่ใจ ?',
            text: `คุณต้องการเพิ่ม Type ${Type_Name}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#56A834',
            cancelButtonColor: '#d33',
            confirmButtonText: 'แน่ใจ',
            cancelButtonText: 'ยังก่อน'
        }).then((result) => {
            if (result.isConfirmed) {
                let form = new FormData();
                form.append("type_name", Type_Name)
                form.append("is_link", GoogleDrive)
                form.append("email", Email)
                form.append("buyer", Buyer)
                form.append("due_time", due_time * 3600)
                settingAPI.AddType(token, form)
                    .then((res) => {
                        if (res.status == 200) {
                            Swal.fire({
                                icon: 'success',
                                confirmButtonColor: "#6ab23a",
                                html: `<span class="colorWhite">${res.message}</span>`,
                                backdrop: 'transparent',
                                background: 'rgba(0,0,0,.75)',
                                customClass: {
                                    icon: 'switchZ'
                                },
                                width: '28rem',
                                timer: 3000
                            }).then((res) => {
                                history.push("/settings/type")
                            })
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${res.message}</span>`,
                                backdrop: 'transparent',
                                background: 'rgba(0,0,0,.75)',
                                customClass: {
                                    icon: 'switch'
                                },
                                width: '28rem',
                                timer: 5000
                            })
                        }
                    })
                    .catch((error) => {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">${error.message}</span>`,
                            backdrop: 'transparent',
                            background: 'rgba(0,0,0,.75)',
                            customClass: {
                                icon: 'switch'
                            },
                            width: '28rem',
                            timer: 5000
                        })
                    })
            }
        })

    }

    return (
        <Container style={{ padding: '20px', backgroundColor: '#ffffffbd', borderRadius: '10px' }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h3><strong>เพิ่ม Type</strong></h3>
                </Grid>
            </Grid>
            <Container style={{ paddingTop: '2rem' }}>
                <div className="row">
                    <div className="pt-5 col-lg-12">
                        <div className="row">
                            <div className="mt-4 col-lg-12">
                                <TextField
                                    style={{ width: '100%' }}
                                    value={Type_Name}
                                    onChange={(event) => setType_Name(event.target.value)}
                                    label="ชื่อ Type…"
                                />
                            </div>
                            <div className="mt-4 col-lg-12">
                                <TextField
                                    type="number"
                                    style={{ width: '14%' }}
                                    value={due_time}
                                    onChange={(event) => setDue_time(event.target.value)}
                                    label="ระยะเวลาทำงาน (ชม.)..."
                                />
                            </div>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <div className="mt-4 col-12">
                                        <label>
                                            <strong>ส่งอีเมลล์</strong>
                                        </label>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={Email} onClick={() => SetEmail(true)} />} label="Yes" />
                                            <FormControlLabel control={<Checkbox checked={!Email} onClick={() => SetEmail(false)} />} label="No" />
                                        </FormGroup>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="mt-4 col-12">
                                        <label>
                                            <strong>Buyer สามารถเห็นได้</strong>
                                        </label>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={Buyer} onClick={() => SetByer(true)} />} label="Yes" />
                                            <FormControlLabel control={<Checkbox checked={!Buyer} onClick={() => SetByer(false)} />} label="No" />
                                        </FormGroup>
                                    </div>
                                </Grid>
                            </Grid>
                            <div className="mt-4 col-12">
                                <label>
                                    <strong>แนบลิงค์ Google Drive</strong>
                                </label>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={GoogleDrive} onClick={() => SetGoogleDrive(true)} />} label="Yes" />
                                    <FormControlLabel control={<Checkbox checked={!GoogleDrive} onClick={() => SetGoogleDrive(false)} />} label="No" />
                                </FormGroup>
                            </div>
                            <div className="mt-4 col-12">
                                <Button variant="contained"
                                    onClick={onSubmit}
                                    disabled={Type_Name == ""}
                                    style={{
                                        border: "2px solid transparent",
                                        backgroundColor: "#6ab23a",
                                        borderRadius: "5px",
                                        color: "white",
                                        fontSize: "16px",
                                        textDecoration: "none",
                                        textTransform: "capitalize",
                                    }}>
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

            </Container>
        </Container >
    )
}

export default Setting_Create_Type